!(function ($) {
  _p.each(['get', 'post', 'put', 'del', 'patch', 'delete'], function (method) {
    var func = $[method];
    $[method] = function (url, data, opt) {
      url = url.match(/^\/@api/) ? '/' + T.lang + url : url;
      return func(url, data, opt);
    };
  });
  $.delete = $.del;
  var upload = $.upload;
  $.upload = function (input_or_form, opt) {
    opt = opt || {};
    opt.url = opt.url || $.UPLOAD_URL || '/@fileUpload/file';
    /* api 시작에 언어가 없으면 LANG을 붙인다. */
    var LANG = window.is_df ? '' : '/' + ((window.T && window.T.lang) || 'kr');
    opt.url = opt.url.match(/^\/@api|^\/@fileUpload/) ? LANG + opt.url : opt.url;
    return upload(input_or_form, opt);
  };
})($);
